<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { useActivity } from "@/stores/activity";
import { onMounted } from "vue";
import Loading from "vue3-loading-overlay";
import { RiUserSmileLine } from "@remixicon/vue";
import { hasSelectedCompany } from "@/utils/companyContext";

const { t } = useI18n();
const activityStore = useActivity();
const { fetchActivities } = activityStore;

onMounted(async () => {
  // Activity feed needs company context (X-COMPANY-ID header).
  if (!hasSelectedCompany()) return;
  await fetchActivities();
});
</script>
<template>
  <div class="border border-neautrals-200 rounded-md bg-white">
    <div class="flex p-4 items-center justify-between shadow">
      <span class="flex">
        <span class="mr-2">{{ t("dashboard.Activity") }}</span>
      </span>
    </div>
    <div class="flex flex-col p-4 max-h-[190px] overflow-y-auto relative">
      <Loading
        :active="activityStore.isLoading"
        :is-full-page="false"
        :width="32"
        :height="32"
      />
      <div
        v-if="activityStore.getActivities.length !== 0"
        v-for="(activity, index) in activityStore.getActivities"
        :key="index"
        class="flex flex-col"
      >
        <div class="flex mt-4 items-center">
          <RiUserSmileLine className="mr-2" />
          <span class="text-right text-xxs text-neautrals-500"
            >{{ activity.userName }} . {{ activity.activityDate }}</span
          >
        </div>
        <span class="text-neautrals-900 font-normal text-xs">{{
          activity.title
        }}</span>
        <p class="text-neautrals-500 text-xs mt-1 mb-1">
          {{ activity.message }}
        </p>
      </div>
    </div>
  </div>
</template>
